import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
// https://redux.js.org/recipes/using-immutablejs-with-redux/#use-a-higher-order-component-to-convert-your-smart-components-immutablejs-props-to-your-dumb-components-javascript-props
import withImmutablePropsToJS from "with-immutable-props-to-js"

// components
import { DashboardHeader } from "app/static/frontend/dashboards/components/DashboardHeader"

// selectors
import {
    selectDashboardsValue,
} from "app/static/frontend/dashboards/selectors"

import {
    selectDashboardWidgetsGlobalDate,
    selectGlobalDateButtonText,
    selectGlobalDateDropdownMenuOptions,
} from "app/static/frontend/dashboards/selectors/dashboardHeaderSelectors"

const mapStateToProps = createStructuredSelector({
    globalDate: selectDashboardWidgetsGlobalDate,
    globalDateButtonText: selectGlobalDateButtonText,
    globalDateCustomFrom: selectDashboardsValue("globalDateCustomFrom"),
    globalDateCustomTo: selectDashboardsValue("globalDateCustomTo"),
    globalDateDropdownMenuOptions: selectGlobalDateDropdownMenuOptions,
    globalDateShouldRenderCustomDatePicker: selectDashboardsValue("globalDateShouldRenderCustomDatePicker"),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(withImmutablePropsToJS(DashboardHeader))
